/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PartNumberChangesMainPageModule} from './part-number-changes-main-page/part-number-changes-main-page.module';
import {PartNumberChangesCreateNewModule} from './part-number-changes-create-new/part-number-changes-create-new.module';
import {PartNumberChangesRoutingModule} from './part-number-changes-routing.module';

@NgModule({
    imports: [
        PartNumberChangesCreateNewModule,
        PartNumberChangesRoutingModule,
        PartNumberChangesMainPageModule
    ]
})

export class PartNumberChangesModule {
}

